import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../utils";
import { FieldWrapper } from "./field-wrapper";

export const inputBaseClasses = cn(
  "block w-full rounded-md bg-white px-3 py-2 text-sm text-slate-900",
  "border border-slate-300 placeholder:text-slate-400",
  "focus:outline-none focus:ring-2 focus:ring-default-500 focus:border-default-500",
  "disabled:bg-slate-50 disabled:text-slate-500 disabled:cursor-not-allowed",
);

type InputFieldProps = {
  label?: string;
  helperText?: string;
  error?: string;
  className?: string;
} & InputHTMLAttributes<HTMLInputElement>;

export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  ({ label, helperText, error, className, id, type, ...props }, ref) => {
    const fieldId =
      id || `input-${label?.toLowerCase().replace(/\s+/g, "-") || "field"}`;

    const input = (
      <input
        ref={ref}
        type={type}
        id={fieldId}
        className={cn(inputBaseClasses, error && "border-red-500", className)}
        {...props}
      />
    );

    if (!label && !helperText && !error) {
      return input;
    }

    return (
      <FieldWrapper
        label={label}
        helperText={helperText}
        error={error}
        id={fieldId}
      >
        {input}
      </FieldWrapper>
    );
  },
);

InputField.displayName = "InputField";
